<template>
  <span :id="el.id">
    <template v-if="customMode">
      <span
        v-if="el.value"
        v-drag
        class="input-def drag-item"
        :id="'image-' + el.id"
        @click="onFocus"
        @v-drag-end="onDragEnd"
        :style="`position: absolute;transform: scale(${el.scale});transform-origin: top left; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;`"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>

        <img
          :src="el.value"
          :alt="el.name"
          :width="`${el.width}px`"
          :height="`${el.height}px`"
        />
        <button @click.prevent="onRemove" class="cursor p-close">X</button>
      </span>
      <form
        v-else
        v-drag
        class="form p-1 drag-item cursor"
        :style="`background: rgba(255, 255, 255, 0.1); color: ${color}; transform: scale(${el.scale});transform-origin: top left; position: absolute; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;display: flex;align-items: center;justify-content: center;`"
        @v-drag-end="onDragEnd"
        @click="onFocus"
      >
        <div
          v-if="el.required"
          style="
            color: red;
            height: 26px;
            font-size: 22px;
            position: absolute;
            left: -12px;
            top: 0;
          "
        >
          *
        </div>
        <span :style="{ fontSize: `${el.width * 0.18125}px` }">Image</span>
        <button @click.prevent="onRemove" class="cursor p-close">X</button>
      </form>
    </template>

    <span
      v-else
      class="input-def"
      :id="el.id"
      :style="`position: absolute;transform: scale(${el.scale});transform-origin: top left; top:${el.top}; left:${el.left}; z-index:1;height: ${el.height}px;width: ${el.width}px;`"
    >
      <img
        :src="el.value"
        :alt="el.name"
        :width="`${el.width}px`"
        :height="`${el.height}px`"
      />
    </span>
  </span>
</template>

<script>
import mixins from "./mixins";

export default {
  mixins: [mixins],
  data() {
    return {};
  },
  props: {
    el: {
      required: true,
    },
  },
  computed: {
    parsed_value() {
      return this.el.value !== null &&
        this.el.value !== undefined &&
        typeof this.el.value === "object"
        ? this.el.value.value ?? this.el.value.fieldKey
        : this.el.value;
    },
    parsed_name() {
      return this.el.name !== null &&
        this.el.name !== undefined &&
        typeof this.el.name === "object"
        ? this.el.name.value ?? this.el.name.fieldKey
        : this.el.name;
    },
  },

  methods: {},
};
</script>

<style>
.p-close {
  visibility: hidden;
}

.drag-item:hover .p-close {
  visibility: visible;
}

.p-close {
  background: transparent;
  border: solid 1px;
}
</style>
